import React from "react";

export default function ErrorText({ formikProps, name }) {
  return formikProps.errors[name] ? (
    <div style={{ color: "red" }}> {formikProps.errors[name]} </div>
  ) : (
    <div />
  );
}
